import { SxProps, Theme } from '@mui/material';
import Pill from '@watershed/ui-core/components/Pill';
import mixinSx from '@watershed/style/mixinSx';

interface NavPillProps {
  label?: string | null;
  tooltip?: string | null;
  sx?: SxProps<Theme>;
}

export default function NavPill({ label, tooltip, sx }: NavPillProps) {
  if (!label) return null;
  return (
    <Pill
      label={label}
      size="small"
      tooltip={tooltip}
      tooltipProps={{
        placement: 'right',
      }}
      sx={mixinSx(
        {
          marginLeft: 'auto',
          color: (theme) => theme.palette.grey20,
          backgroundColor: (theme) => theme.palette.grey70,
          '[data-appears-collapsed="true"] &': {
            display: 'none',
          },
        },
        sx
      )}
    />
  );
}
